export default __webpack_public_path__ + "static/media/frg--outdoor-cinema.8c52c50a.png";